import React, { useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import { useSelector, useDispatch } from "react-redux";
import { setObjectTypeName } from "../../../redux/actions/jiraAssetsActions";

const ObjectTypeNameInput = ({ defaultName }) => {
  const objectTypeName = useSelector((state) => state.jiraAssets.objectTypeName);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setObjectTypeName(defaultName));
  }, [defaultName]);

  const onChange = (e) => {  
    dispatch(setObjectTypeName(e.target.value));
  };

  return (
    <div>
      Object Type Name:
      <Textfield
        value={objectTypeName ? objectTypeName : ""}
        onChange={onChange}
      />
      This will be the name of the object type that the imported users are added to.
    </div>
  );
};

export default ObjectTypeNameInput;